export const convertSecondsToTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    return { hours: hours <= 0 ? 0 : hours, minutes: minutes <= 0 ? 0 : minutes, seconds: remainingSeconds <= 0 ? 0 : remainingSeconds };
};

export const convertTimeToSeconds = (currentTime) => {
    const seconds =
      (currentTime.hours || 0) * 3600 +
      (currentTime.minutes || 0) * 60 +
      (currentTime.seconds || 0);

    return seconds;
};

export const getQuarterString = (quarter) => `${quarter === 1 ? '1st' : quarter === 2 ? '2nd' : quarter === 3 ? '3rd' : quarter === 4 ? '4th' : '--'}`;

// const toCheckQuarterTime = [0, 10, 20, 30];
  
// export const checkIsEqualToQuarterTime = (totalSeconds) => {
//     const quarterTimesInSeconds = toCheckQuarterTime.map((minutes) => {
//       return convertTimeToSeconds({ hours: 0, minutes, seconds: 0 });
//     });

//     if (quarterTimesInSeconds.includes(totalSeconds)) {
//       return true;
//     } else {
//       return false;
//     }
// };


export const checkIsEqualToQuarterTime = (totalSeconds, gameDetails) => {
    const matchTotalTime = Number(gameDetails.matchPlayTime); // in minutes
    const timePerQuarter = Math.ceil(matchTotalTime / gameDetails.matchQuaters);
    
    const minTimerValue = (matchTotalTime - (gameDetails.currentMatchQuater * timePerQuarter)) * 60;
    // const maxTimerValue = minTimerValue + (timePerQuarter * 60);

    if(minTimerValue === totalSeconds){
        return true;
    }else {
         return false;
    }
    
}